<template lang="pug">
.toolbar(role="banner")
  a.logo(href="/")
    img(alt="Xendity Logo", src="@/assets/images/xendity-logo.png")
  div
    span.mx-2
      router-link(to="/") Overview
    span.mx-2
      router-link(to="/developer") Developer
    span.mx-2
      router-link(to="/features") Features
    span.mx-2
      router-link(to="/pricing") Pricing
    span.mx-2
      router-link(to="/contact") Contact Us
  div
    router-link.btn.btn-login.mr-4(
      v-if="!$store.getters.isLoggedIn",
      to="/auth?mode=login",
      tag="button"
    ) Login
    button.btn.btn-login.mr-4(v-else, @click="logout") Logout
    router-link.btn.btn-blue.mr-4(
      v-if="!$store.getters.isLoggedIn",
      to="/auth?mode=register",
      tag="button"
    ) Try it Free
    router-link.btn.btn-blue.mr-4(v-else, :to="$store.getters.redirectRoute", tag="button") Try it Free
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    logout() {
      this.$store.dispatch("user/logout");
    },
  },
};
</script>
